import { render } from "./ObjBar.vue?vue&type=template&id=3ad2c8a6"
import script from "./ObjBar.vue?vue&type=script&lang=js"
export * from "./ObjBar.vue?vue&type=script&lang=js"

import "./ObjBar.vue?vue&type=style&index=0&id=3ad2c8a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__